import { createContext, useContext } from 'react'
import { CheckboxGroupState } from '@react-stately/checkbox'

export const CheckboxGroupContext = createContext<CheckboxGroupState | null>(null)

export const useCheckboxGroupContext = () => {
  const context = useContext(CheckboxGroupContext)
  if (!context) {
    throw new Error('CheckboxGroupContext must be used within a CheckboxGroup')
  }
  return context as CheckboxGroupState
}
